<button
	close-overlay
	class="close-button"
	[size]="20"
	(click)="close()"
></button>

<div class="swap-header">
	<typography variant="h/3">Swap mention</typography>
	<typography variant="p/sm_regular" class="swap-header__hint">
		Quote another of the brand's mentions from this report's period. The
		card keeps its heading, and hides the author if it did.
	</typography>
</div>

<app-primary-input
	class="swap-search"
	placeholder="Search the mentions"
	icon="search"
	iconPosition="left"
	ariaLabel="Search the mentions"
	height="2.5rem"
	borderRadius="0.75rem"
	[inputControl]="searchControl"
	[focusSubject]="focusSearch"
></app-primary-input>

<div class="swap-list" aria-label="Mentions">
	<button
		type="button"
		class="swap-option"
		*ngFor="let option of options; trackBy: trackById"
		[class.swap-option--current]="option.current"
		[attr.aria-current]="option.current ? 'true' : null"
		(click)="pick(option)"
	>
		<div class="swap-option__head">
			<app-social-listening-platform-icon
				[size]="16"
				[socialListeningPlatform]="option.platform"
			></app-social-listening-platform-icon>
			<typography variant="p/sm_medium" class="swap-option__author">
				{{ option.author }}
			</typography>
			<typography variant="p/xs_regular" class="swap-option__meta">
				{{ option.platformLabel }}
				<ng-container *ngIf="option.postedAt">
					· {{ option.postedAt | date: 'd MMM y':'UTC' }}
				</ng-container>
			</typography>
			<typography
				variant="p/xs_semibold"
				class="swap-option__current"
				*ngIf="option.current"
			>
				In the card
			</typography>
		</div>
		<typography variant="p/xs_regular" class="swap-option__excerpt">
			{{ option.excerpt }}
		</typography>
	</button>

	<typography
		variant="p/sm_regular"
		class="swap-nothing"
		*ngIf="!loading && !options.length"
	>
		<ng-container *ngIf="query; else noMentions">
			No mention in this period matches “{{ query }}”.
		</ng-container>
		<ng-template #noMentions>
			No mentions to show for this period.
		</ng-template>
	</typography>

	<typography variant="p/sm_regular" class="swap-nothing" *ngIf="loading">
		Loading mentions…
	</typography>

	<button
		type="button"
		class="swap-more"
		*ngIf="hasMore && !loading"
		(click)="showMore()"
	>
		<typography variant="p/sm_medium">Show more</typography>
	</button>
</div>
